import React, {useContext, useEffect, useRef} from "react";
import Lightbox from "react-datatrans-light-box";
import {TicketDetailsContext} from "../components/TicketDetailsContext";
import PayrexxModal from "./PayrexxModal";

const BeppoLightBox = () => {
  const {
    isProduction,
    onLoaded,
    onOpened,
    onCancelled,
    onError,
    transaction,
    payrexxInstance,
    countryCode,
    lightbox
  } = useContext(TicketDetailsContext)

  if (!lightbox || !transaction || !countryCode) {
    return null;
  }


  if (countryCode === "DE" || countryCode === "AT") {
    console.log("Should open Payrexx payment modal")

    return (
        <PayrexxModal
            gatewayUrl={`https://${payrexxInstance}.payrexx.com/?payment=${transaction}`}
            onSuccess={(response) => {
              console.log("Payrexx succeeded", response);
            }}
            onError={onError}
            onLoaded={onLoaded}
            onOpened={onOpened}
        />
    );
  } else if (countryCode === "CH") {
    console.log("Should open Datatrans payment lightbox")

    return (
        <Lightbox
            transactionId={transaction}
            production={isProduction}
            onLoaded={onLoaded}
            onOpened={onOpened}
            onCancelled={onCancelled}
            onError={onError}
        />
    );
  } else {
    console.error("Unexpected country code", countryCode)

    return null;
  }
};

export default BeppoLightBox;
